module.exports = __webpack_public_path__ + "img/golden-2.eed36065.png";